var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Copy 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC69\\u200D\\uD83C\\uDF93-Students-management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin-/-Dashboard-/-Manage-Students-/-Total-Count",
    transform: "translate(-356, -178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stats",
    transform: "translate(96, 152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Total-Copy",
    transform: "translate(236, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Copy-6",
    transform: "translate(0, 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    fill: "#423158",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/User-friend/Filled",
    transform: "translate(10.5, 10.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90097642,14.7053569 C6.70921858,15.082031 7.59867168,15.3080355 8.54999978,15.3080355 C9.46836011,15.3041934 10.3739433,15.098164 11.1990232,14.7053569 L11.52116,14.7053569 C13.9813215,14.7066 15.9749997,16.6495114 15.9749997,19.0457727 L15.9749997,20.1294643 C15.9749997,21.128016 15.1439294,21.9375 14.1187496,21.9375 L2.98124995,21.9375 C1.95607017,21.9375 1.125,21.128016 1.125,20.1294643 L1.125,19.0446426 C1.12565742,16.6483775 3.11983448,14.70598 5.57999988,14.7053569 Z M17.9782023,14.7053431 C18.5157413,14.8861607 19.0842178,15.0066964 19.6874991,15.0066964 C20.2907803,15.0066964 20.8592569,14.8861607 21.3967959,14.7053431 L21.5481963,14.7053431 C23.9389844,14.7065113 25.8761663,16.5952042 25.8749995,18.9239053 L25.8688461,19.0723943 C25.7914071,20.0015835 24.9926697,20.7321428 24.0187489,20.7321428 L17.189296,20.7321428 C17.1931632,20.6530412 17.2124991,20.5739397 17.2124991,20.4910714 L17.2124991,19.0446428 C17.2124991,17.5906807 16.6208195,16.2760881 15.6772258,15.2854352 C16.3153117,14.9275948 17.0423429,14.7053431 17.8312491,14.7053431 Z M19.6874989,6.26785714 C21.7378546,6.26785714 23.3999988,7.88682881 23.3999988,9.88392855 C23.3999988,11.8810283 21.7378546,13.5000005 19.6874989,13.5000005 L19.4903321,13.4949881 C17.5316377,13.3951572 15.974999,11.8166063 15.974999,9.8839291 L15.9801451,9.6918829 C16.0826381,7.7840637 17.7032837,6.26785714 19.6874989,6.26785714 Z M8.54999918,5.0625 C10.9420828,5.0625 12.8812491,6.9512984 12.8812491,9.28124998 C12.8812491,11.6112016 10.9420828,13.5000143 8.54999918,13.5000143 C6.15476375,13.4988461 4.21758202,11.6101532 4.21874866,9.28145217 L4.22374329,9.07684771 C4.33320911,6.84182652 6.22827101,5.0625 8.54999918,5.0625 Z",
    id: "Icon",
    fill: "#AD79EF"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserGroup);
export default __webpack_public_path__ + "static/media/icon-user-group.b17f2f27.svg";
export { ForwardRef as ReactComponent };